import axios from "axios";

export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  if ((config.method || "").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _ts: Date.now() };
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const msg = err?.response?.data?.message || err?.response?.data?.mensaje;
    if (err?.response?.status === 401 && msg && msg.includes("Token inválido")) {
      localStorage.removeItem("token");
      localStorage.removeItem("usuario");
      localStorage.removeItem("rm:user");
    }
    return Promise.reject(err);
  }
);

function unwrap(res) {
  return res.data;
}

// -------- USUARIOS --------
export async function loginApi({ correo, password }) {
  const data = await api.post("/usuarios/login", { correo, password }).then(unwrap);
  if (data?.token) localStorage.setItem("token", data.token);
  if (data?.usuario) {
    localStorage.setItem("usuario", JSON.stringify(data.usuario));
    localStorage.setItem("rm:user", JSON.stringify(data.usuario));
  }
  return data;
}

export async function registerApi({ nombreUsuario, correo, password }) {
  return api.post("/usuarios", { nombreUsuario, correo, password }).then(unwrap);
}

export async function deleteUser(id) {
  return api.delete(`/usuarios/${id}`).then(unwrap);
}

// -------- RECUPERACIÓN DE CONTRASEÑA --------
export async function solicitarRecuperacionPassword({ correo }) {
  return api
    .post("/usuarios/recuperar-password", { correo })
    .then(unwrap);
}

export async function obtenerDatosRecuperacion(token) {
  return api
    .get("/usuarios/datos-recuperacion", { params: { token } })
    .then(unwrap);
}

export async function actualizarPasswordRecuperacion({ token, password }) {
  return api
    .post("/usuarios/actualizar-password-recuperacion", {
      token,
      password
    })
    .then(unwrap);
}

// -------- MEDICAMENTOS --------
export async function getMedicamentos(params = {}) {
  return api.get("/medicamentos", { params }).then(unwrap);
}

export async function getMedicamentoById(id) {
  return api.get(`/medicamentos/${id}`).then(unwrap);
}

// -------- FAVORITOS --------
export async function getFavoritos() {
  return api.get("/favoritos").then(unwrap);
}

export async function addFavorito(medicamentoId) {
  return api.post("/favoritos", { medicamento_id: medicamentoId }).then(unwrap);
}

export async function removeFavorito(medicamentoId) {
  return api.delete("/favoritos", { data: { medicamento_id: medicamentoId } }).then(unwrap);
}

// -------- RECOMENDACIONES --------
export async function getReco(medicamentoId, limite = 8) {
  return api
    .get(`/api/medicamentos/${medicamentoId}/recomendaciones`, { params: { limite } })
    .then(unwrap);
}

// -------- ALERTAS --------
export async function createUpdateAlert({ medicamento_id, umbralPrecio, activa = true }) {
  return api.post("/alertas", { medicamento_id, umbralPrecio, activa }).then(unwrap);
}

export async function getAlertas() {
  return api.get("/alertas").then(unwrap);
}

export async function deleteAlert({ medicamento_id }) {
  return api.delete("/alertas", { data: { medicamento_id } }).then(unwrap);
}